import React from 'react';
import { BuildPath } from  '@/helpers/Paths';

const GenError = () => {
    return (
        <div className="gen-error">
            <img src={`${BuildPath()}/images/unsplash/missing.svg`} alt="Error" />
            <span>Error: please try again later</span>
        </div>
    );
};

export default GenError;